module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/ant-mobile-portuguese.95631d73.jpg";